import React from "react";
import { Box, Typography, Button } from "@mui/material";
import English from "../../components/img/English.png";
import calculate from "../../components/img/calculate.png";
import eco from "../../components/img/eco.png";
import experiment from "../../components/img/experiment.png";
import lang from "../../components/img/Lang.png";
import li_icon from "../img/icon/li_icon_black.png";

import "../../styles/components-styles/Courses.css";
import { useNavigate } from "react-router-dom";

const CourseCard = ({ imgSrc, title, points }) => {
  return (
    <Box className="course-card">
      <Box className="course-card-header">
        <Box className="course-card-icon">
          <img
            src={imgSrc}
            alt={title}
            style={{ height: "42px", width: "42px" }}
          />
        </Box>
        <Box className="course-card-title">
          <Typography variant="h6" className="course-card-title-text">
            {title}
          </Typography>
        </Box>
      </Box>

      <Box component="ul" className="course-card-list">
        {points.map((point, index) => (
          <Box key={index} component="li" className="course-card-list-item">
            <img src={li_icon} alt="." className="course-card-list-icon" />
            <Typography variant="body2" className="course-card-list-text">
              {point}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const Courses = () => {
  const navigate = useNavigate();

  const enrollClick = () => {
    navigate("/ContactUs");
  };
  const courses = [
    {
      imgSrc: calculate,
      title: "Mathematics",
      points: [
        "Conceptual Clarity And Step-By-Step Problem-Solving Approaches.",
        "Advanced Practice Sessions, Including NCERT And Competitive-Level Questions.",
        "Special Focus On Analytical And Logical Reasoning Skills.",
      ],
    },
    {
      imgSrc: English,
      title: "English",
      points: [
        "Literature And Grammar Mastery With A Focus On CBSE/ICSE Syllabi.",
        "Creative Writing, Comprehension, And Vocabulary Building.",
        "Spoken English And Communication Skill Enhancement.",
      ],
    },
    {
      imgSrc: eco,
      title: "Social Studies",
      points: [
        "In-Depth Coverage Of History, Geography, Political Science, And Economics.",
        "Simplified Explanations Of Complex Topics For Better Retention.",
        "Map Work And Project Support For Practical Learning.",
      ],
    },
    {
      imgSrc: experiment,
      title: "Science",
      points: [
        "Interactive Lessons Covering Physics, Chemistry, And Biology.",
        "Hands-On Experiments And Project Guidance To Enhance Learning.",
        "Exam-Oriented Preparation With Regular Assessments.",
      ],
    },
    {
      imgSrc: lang,
      title: "Languages",
      points: [
        "Guidance For Second And Third Languages, Including Hindi.",
        "Grammar, Writing, And Speaking Practice Tailored To Individual Needs.",
      ],
    },
  ];

  return (
    <Box className="courses-container">
      <Box
        sx={{ width: "75%", height: "fit-content" }}
        className="courses-title-body"
      >
        <Typography variant="h4" className="courses-heading">
          OUR COURSES
        </Typography>
        <Typography variant="body1" className="courses-text">
          Master every subject with our meticulously designed curriculum
          tailored for students in grades 5-10. Our program provides expert
          guidance across all subjects, ensuring academic success and holistic
          development.
        </Typography>
      </Box>

      <Box className="courses-wrapper">
        {courses.map((course, index) => (
          <Box
            key={index}
            className={
              index === courses.length - 1 ? "last-course" : "all-course"
            }
          >
            <CourseCard
              imgSrc={course.imgSrc}
              title={course.title}
              points={course.points}
            />
          </Box>
        ))}
      </Box>

      <Box
        className="button-body"
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: "40vh",
          position: "absolute",
        }}
      >
        <Button
          variant="contained"
          className="enroll-button"
          onClick={() => {
            enrollClick();
            window.scrollTo({ top: 0 });
          }}
        >
          Enroll Now
        </Button>
      </Box>
    </Box>
  );
};

export default Courses;
